import AssessmentTable from '@/components/AssessmentTable.vue'
import CourseManagerPage from '@/components/CourseMangerPage.vue'
import EmployeeList from '@/components/EmployeeList.vue'
import LearningRecord from '@/components/LearningRecord.vue'
import LoginPage from '@/components/LoginPage.vue'
import MainPage from '@/components/MainPage.vue'
import PerformanceRule from '@/components/PerformanceRule.vue'
import { Role } from '@/constants/Role'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/ding-login',
        name: 'DingLogin',
        component: () => import('@/pages/ding-login.vue'),
        meta: { guestOnly: true }
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: { guestOnly: true }
    },
    {
        path: '/main',
        name: 'Main',
        component: MainPage,
        meta: { requiresAuth: true },
        children: [
            {
                path: '/employee-list',
                name: 'EmployeeList',
                component: EmployeeList,
                meta: {
                    requiresAuth: true,
                    title: '花名册',
                    requiredRole: [Role.ADMIN]
                },
                children: [
                    {
                        path: 'profile/:id',
                        name: 'EmployeeProfile',
                        component: () => import('@/components/EmployeeProfile.vue'),
                        meta: {
                            requiresAuth: true,
                            title: '员工档案'
                        },
                        props: true
                    },
                    {
                        path: 'organization-import',
                        name: 'OrganizationImport',
                        component: () => import('@/components/OrganizationImport.vue'),
                        meta: {
                            requiresAuth: true,
                            title: '导入组织架构'
                        }
                    }
                ]
            },
            {
                path: '/staff-statistics',
                name: 'StaffStatistics',
                component: () => import('@/components/StaffStatisticsPage.vue'),
                meta: {
                    requiresAuth: true,
                    title: '档案分析',
                    requiredRole: [Role.ADMIN]
                }
            },

            {
                path: 'performance/assessment/:ruleId/:ruleName',
                name: 'AssessmentTable',
                component: AssessmentTable,
                meta: {
                    requiresAuth: true,
                    title: '考核表'
                },
                props: true
            },
            {
                path: '/performance',
                name: 'Performance',
                component: () => import('@/components/PerformanceLayout.vue'),
                meta: {
                    requiresAuth: true,
                    title: '绩效考核'
                },
                children: [
                    // 绩效管理
                    {
                        path: 'management',
                        name: 'PerformanceManagement',
                        component: () => import('@/components/PerformanceWrapper.vue'),
                        meta: { title: '绩效管理' },
                        children: [
                            {
                                path: '/performance/rule',
                                name: 'AssessmentRule',
                                component: PerformanceRule,
                                meta: { title: '考核规则' }
                            },
                            {
                                path: '/performance/category-manage',
                                name: 'CategoryManage',
                                component: () => import('@/components/CategoryManage.vue'),
                                meta: {
                                    title: '管理关键指标',
                                    requiredRole: [Role.SUPER]
                                }
                            },
                            {
                                path: '/performance/fixed-dimension-manage',
                                name: 'FixedDimensionManage',
                                component: () => import('@/components/FixedDimensionManage.vue'),
                                meta: {
                                    title: '固定考核规则管理',
                                    requiredRole: [Role.SUPER]
                                }
                            },
                            {
                                path: '/performance/manage',
                                name: 'AssessmentTemplate',
                                component: () => import('@/components/PerformanceManager.vue'),
                                meta: { title: '考核管理' }
                            },
                            {
                                path: '/performance/plan/:planId/:planName',
                                name: 'PerformanceList',
                                component: () => import('@/components/PerformanceList.vue'),
                                props: true
                            },
                            {
                                path: '/performance/detail/:planId',
                                name: 'PerformancePlanDetail',
                                component: () => import('@/components/PerformancePlanDetail.vue'),
                                props: true,
                                meta: {
                                    title: '考核计划详情'
                                }
                            },
                            {
                                path: '/performance/rule/:ruleId/:ruleName',
                                name: 'AssessRuleDetail',
                                component: () => import('@/components/rule/AssessmentTableShow.vue'),
                                props: true,
                                meta: {
                                    title: '考核规则详情'
                                }
                            },
                            {
                                path: '/performance/my-performance',
                                name: 'AssessmentRecord',
                                component: () => import('@/components/MyPerformance.vue'),
                                meta: { title: '我的绩效' }
                            }
                        ]
                    },
                    //绩效分析
                    {
                        path: '/performance/analysis',
                        name: 'PerformanceAnalysis',
                        component: () => import('@/components/PerformanceWrapper.vue'),
                        meta: { title: '绩效分析' },
                        children: [
                            {
                                path: '/performance/employee',
                                name: 'DepartmentPerformance',
                                component: () => import('@/components/EmployeeAnalysis.vue'),
                                meta: { title: '员工分析', requiredRole: [Role.ADMIN, Role.SUPER]}
                            },
                            {
                                path: '/performance/archive',
                                name: 'PersonalPerformance',
                                component: () => import('@/components/PersonalPerformance.vue'),
                                meta: { title: '绩效档案', requiredRole: [Role.ADMIN, Role.SUPER]}
                            },
                            {
                                path: '/performance/department',
                                name: 'DepartmentPerformancePage',
                                component: () => import('@/components/DepartmentPerformance.vue'),
                                meta: { title: '部门绩效', requiredRole: [Role.ADMIN, Role.SUPER]}
                            }
                        ]
                    }
                ]
            },
            // 新增企业培训菜单路由
            {
                path: '/training',
                name: 'Training',
                component: () => import('@/components/TrainingLayout.vue'),
                meta: {
                    requiresAuth: true,
                    title: '企业培训'
                },
                children: [
                    // 课程管理路由
                    {
                        path: '/course-manager',
                        name: 'CourseManager',
                        component: CourseManagerPage,
                        meta: {
                            requiresAuth: true,
                            title: '课程管理',
                            requiredRole: [Role.ADMIN, Role.SUPER]
                        }
                    },
                    // 我的培训路由（新增）
                    {
                        path: '/my-training',
                        name: 'MyTraining',
                        component: () => import('@/components/MyTraining.vue'),
                        meta: {
                            requiresAuth: true,
                            title: '我的培训'
                        }
                    },
                    {
                        path: '/learning-record',
                        name: 'LearningRecord',
                        component: LearningRecord,
                        meta: {
                            requiresAuth: true,
                            title: '学习记录',
                            requiredRole: [Role.ADMIN, Role.SUPER]
                        }
                    },
                    // 新增员工培训详情页面路由
                    {
                        path: '/employee-training-detail/:id',
                        name: 'LearningRecordDetail',
                        component: () => import('@/components/LearningRecordDetail.vue'),
                        meta: {
                            requiresAuth: true,
                            title: '培训详情'
                        }
                    }
                ]
            }
        ]
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    console.log("to", to)
    console.log("from", from)
    // Get store from the app instance
    const app = router.app
    const myRole = (app && app.$store) ? app.$store.getters['user/getUserRole'] : localStorage.getItem('role')

    // 检查是否需要特定角色
    if (to.meta?.requiredRole && !to.meta.requiredRole.includes(myRole)) {
        if (from.name !== 'Main') {
            next({name: "Main"})
            console.log("🚀 ~ Main:")
        } else {
            next(false)
            console.log("🚀 ~ false:")

        }
    } else {
        console.log("🚀 ~ else:", )
        next()
    }

})

export default router